import { db } from "./db";

// ---- Read cache ----

export async function cacheRead(url, entityType, data) {
  try {
    await db.readCache.put({ key: url, entityType, data, timestamp: Date.now() });
  } catch (e) {
    console.log(e, "offline cacheRead failed");
  }
}

export async function getCachedRead(url) {
  try {
    return await db.readCache.get(url);
  } catch (e) {
    console.log(e, "offline getCachedRead failed");
    return undefined;
  }
}

// ---- Write queue ----

export async function queueMutation({ entityType, method, url, payload, displayRow }) {
  const tempId = `offline-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  await db.writeQueue.add({
    entityType,
    method,
    url,
    payload,
    displayRow: displayRow || null,
    tempId,
    status: "pending",
    createdAt: Date.now(),
    lastError: null,
  });
  return tempId;
}

export async function getPendingForEntity(entityType) {
  return db.writeQueue.where({ entityType }).toArray();
}

export async function getPendingCount() {
  return db.writeQueue.count();
}

// Replays queued mutations in creation order. Stops at the first failure so
// writes are never replayed out of order; the next online transition (or a
// manual retry) picks up from where it left off.
export async function syncQueue() {
  const { axiosPrivate } = await import("../axios/axios");
  const queued = await db.writeQueue.orderBy("createdAt").toArray();

  let syncedCount = 0;
  for (const item of queued) {
    try {
      await axiosPrivate.request({
        method: item.method,
        url: item.url,
        data: item.payload,
      });
      await db.writeQueue.delete(item.id);
      syncedCount += 1;
      window.dispatchEvent(
        new CustomEvent("offlineSyncSuccess", { detail: { entityType: item.entityType } }),
      );
    } catch (e) {
      await db.writeQueue.update(item.id, {
        status: "failed",
        lastError: e?.response?.data?.failureMessage || e?.message || "Sync failed",
      });
      console.log(e, "offline sync failed, stopping queue for now");
      break;
    }
  }
  return syncedCount;
}
